import { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'

export default function useSearchParams() {
  const [params, setParams] = useState({ finished: false })
  const history = useHistory()

  const getSearchParams = useCallback(() => {
    const query = new URLSearchParams(window.location.search)
    const page = query.get('page')
    const filters = {}

    query.forEach((val, key) => {
      if (val && val !== 'undefined' && key !== 'page') {
        filters[key] = val
      }
    })

    setParams({ page, filters, finished: true })
  }, [])

  useEffect(() => {
    getSearchParams()
  }, [getSearchParams])

  const setSearchParams = (searchParams) => {
    const query = new URLSearchParams(searchParams)
    history.push({ search: query.toString() })
  }

  return [params, setSearchParams]
}
